export default "__VITE_ASSET__ByUCnePb__"